"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AmountComponent = (function () {
    function AmountComponent() {
        this.element = document.getElementById('cibCtrlLeft');
    }
    AmountComponent.prototype.render = function (amounts) {
        this.element.innerHTML = '';
        for (var counter = 0; counter < amounts.length; counter++) {
            this.element.innerHTML += "<div class=\"ctrl-amount\">\n                <p data-money =\"" + amounts[counter].MoneyValue + "\" \n                data-counter=\"" + amounts[counter].Counter + "\" >" + amounts[counter].MoneyValue + "</p></div>";
        }
    };
    return AmountComponent;
}());
exports.default = AmountComponent;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/components/betting/amount/amount.ts
// module id = 2396
// module chunks = 5